import { createSelector } from '@reduxjs/toolkit';

import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.ProfilesList;

export const statusSelector = createSelector(rootSelector, (profiles) => profiles.status);

export const errorSelector = createSelector(rootSelector, (profiles) => profiles.error);

const profilesSelector = createSelector(rootSelector, (profiles) => profiles.data);
export const ProfileById = createSelector(
  profilesSelector,
  (data) => (id?: string) => data && data.find((dataItem) => dataItem.id.toString() === id)
);

export default {
  statusSelector,
  errorSelector,
  profilesSelector,
  ProfileById,
};
